import React, { useEffect, useState, useRef } from "react";
import {
  Badge,
  Button,
  Form,
  OverlayTrigger,
  Tooltip,
  Modal,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import authApi from "../../api/authApi";
import jwt_decode from "jwt-decode";
import { isMobile } from "react-device-detect";
import helper from "../common/helper";
import { NameInitialsAvatar } from "react-name-initials-avatar";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import { FaBell, FaUserPlus, FaWhatsapp } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";
import moment from "moment";
import IncomingCalls from "../calls/IncomingCalls";

const bgColors = [
  "#d3761f",
  "#00ad5b",
  "#debf31",
  "#239dd1",
  "#b67eb1",
  "#d3761f",
  "#de242f",
];
let notifColorIndex = 0;
const fillNotifBgColor = () => {
  notifColorIndex += 1;
  if (notifColorIndex >= bgColors.length) notifColorIndex = 0;
  return bgColors[notifColorIndex];
};

const Header = ({ socket, onWhatsAppSettingChange }) => {
  // 🔔 Notification sound
  const audioRef = useRef(null);
  const soundUnlockedRef = useRef(false);
  const unreadContactsMapRef = useRef({});
  const [owners, setOwners] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState({});
  const { tenantcode } = jwt_decode(sessionStorage.getItem("token"));
  const profileImage = `/public/${tenantcode}/users`;

  const [brokenImages, setBrokenImages] = useState([]);
  const [whatsappSetting, setWhatsappSetting] = useState([]);
  const [selectedSetting, setSelectedSetting] = useState(
    sessionStorage.getItem("selectedWhatsAppSetting") || "",
  );

  // Notification bell state
  const [showNotif, setShowNotif] = useState(false);
  const [unreadMessages, setUnreadMessages] = useState([]);
  const notifRef = useRef(null);

  // Toast notifications for new messages
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [toasts, setToasts] = useState([]); // Store multiple toasts

  const [showLeadNotif, setShowLeadNotif] = useState(false);
  const [leadNotifications, setLeadNotifications] = useState([]);
  const leadNotifRef = useRef(null);

  const [showCallUI, setShowCallUI] = useState(true);
  const [callEventReceived, setCallEventReceived] = useState(false);
  const [unreadContactsMap, setUnreadContactsMap] = useState({});

  // Check if current page is home/app.jsx
  const isHomePage = () => {
    return (
      location.pathname === "/" ||
      location.pathname === "/home" ||
      location.pathname === "/app"
    );
  };

  const unlockNotificationSound = () => {
    if (soundUnlockedRef.current) return;

    try {
      if (!audioRef.current) {
        audioRef.current = new Audio("/ringtone.wav");
        audioRef.current.volume = 0.3;
      }

      audioRef.current
        .play()
        .then(() => {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          soundUnlockedRef.current = true;
        })
        .catch(() => {});
    } catch (e) {}
  };

  // useEffect(() => {
  //   // Refresh unread messages every 30 seconds
  //   // const interval = setInterval(() => {
  //   //   if (!showNotif) {
  //   //     fetchUnreadMessages();
  //   //   }
  //   // }, 30000);

  //   return () => clearInterval(interval);
  // }, [selectedSetting, showNotif]);

  useEffect(() => {
    const unlock = () => {
      unlockNotificationSound();
      window.removeEventListener("click", unlock);
      window.removeEventListener("keydown", unlock);
    };

    window.addEventListener("click", unlock);
    window.addEventListener("keydown", unlock);

    return () => {
      window.removeEventListener("click", unlock);
      window.removeEventListener("keydown", unlock);
    };
  }, []);
  const fetchOwners = async () => {
    const users = await WhatsAppAPI.getLoginUserData();

    if (users) setOwners(users);

    // ✅ Decode token here
    const token = sessionStorage.getItem("token");
    let decoded = null;

    try {
      decoded = jwt_decode(token);
    } catch (e) {
      console.log("Invalid token");
      return;
    }
    // ✅ Safety check
    if (!decoded?.password_changed_at || !users?.password_changed_at) {
      console.log("Missing password_changed_at");
      return;
    }
    const tokenTime = new Date(decoded.password_changed_at + "Z").getTime();
    const dbTime = new Date(users.password_changed_at).getTime();

    if (Math.abs(tokenTime - dbTime) > 1000) {
      authApi.logout();
    }
  };

  useEffect(() => {
    fetchData();
    fetchUnreadMessages();
    fetchOwners();
    if (!sessionStorage.getItem("token")) navigate("/login");
    try {
      setUserInfo(jwt_decode(sessionStorage.getItem("token")));
    } catch (error) {
      // console.log(error)
    }

    socket?.on("greetings", (data) => {
      // messageList();
    });

    // Listen for real-time WhatsApp messages to update unread count
    socket?.on("receivedwhatsappmessage", (data) => {
      const isIncomingMessage = data?.from && data?.type && !data?.status;

      if (isIncomingMessage) {
        const fromNumber = data.from || "";
        const numberWithoutPlus = fromNumber.replace("+", "");

        // Get the latest map from ref
        const currentMap = unreadContactsMapRef.current;

        // Check if this number exists in our unread contacts map
        const isUnreadContact =
          currentMap[fromNumber] || currentMap[numberWithoutPlus];
        // console.log(
        //   "isUnreadContact check:",
        //   isUnreadContact,
        //   "fromNumber:",
        //   fromNumber,
        //   "numberWithoutPlus:",
        //   numberWithoutPlus,
        //   "currentMap keys:",
        //   Object.keys(currentMap)
        // );

        // ONLY show notification if it matches an unread record
        if (isUnreadContact) {
          // console.log(
          //   "✅ Notification triggered for unread contact:",
          //   fromNumber
          // );
          playNotificationSound();
          showNewMessageToast(data);

          // Auto-redirect if on home page
          if (isHomePage()) {
            setTimeout(() => {
              navigate("/whatsapp_messenger", {
                state: {
                  fromNotification: true,
                  phoneNumber: data.from,
                  messageId: data.id,
                },
              });
            }, 2000);
          }
        } else {
          // console.log(
          //   "❌ No notification - not an unread contact:",
          //   fromNumber
          // );
        }
      }

      // Always update unread messages
      fetchUnreadMessages();
    });

    // Listen for when messages are marked as read
    socket?.on("messagesmarkedasread", (data) => {
      fetchUnreadMessages();
    });

    socket?.on("new-lead-assigned", (data) => {
      playNotificationSound();
      handleNewLeadAssignment(data);
    });

    socket?.on("lead-reassigned", (data) => {
      playNotificationSound();
      handleNewLeadAssignment(data);
    });

    return () => {
      socket?.off("receivedwhatsappmessage");
      socket?.off("messagesmarkedasread");
      socket?.off("new-lead-assigned");
      socket?.off("lead-reassigned");
    };
  }, [socket, selectedSetting, location.pathname]); // Removed unreadContactsMap from dependencies  // Function to show new message toast notification
  // Function to show new message toast notification
  const showNewMessageToast = (messageData) => {
    // Format the phone number for display
    const formatNumberForToast = (number) => {
      const shouldHideNumber =
        userInfo?.userrole !== "ADMIN" &&
        userInfo?.is_whatsapp_number_hidden === true;

      if (shouldHideNumber && number) {
        const numberString = String(number);
        if (numberString.length <= 5) return numberString;
        const visibleDigits = numberString.slice(-5);
        const maskedDigits = "X".repeat(numberString.length - 5);
        return `${maskedDigits}${visibleDigits}`;
      }
      return number;
    };

    // Extract and format the from number
    const fromNumber = messageData.from || "";
    let displayNumber = fromNumber;

    if (fromNumber) {
      // Remove + sign if present
      const cleanNumber = fromNumber.replace("+", "");

      // Format for display
      if (cleanNumber.length > 10) {
        // Remove country code for display
        displayNumber = cleanNumber.substring(2);
      } else {
        displayNumber = cleanNumber;
      }

      // Apply masking if needed
      displayNumber = formatNumberForToast(displayNumber);
    }

    const formattedMessage = {
      id: Date.now(),
      from: messageData.from,
      contactName: messageData.contact_name || displayNumber,
      originalContactName: messageData.contact_name,
      displayNumber: displayNumber,
      message: messageData.text?.body || "New message",
      timestamp: messageData.timestamp
        ? new Date(parseInt(messageData.timestamp) * 1000)
        : new Date(),
      messageId: messageData.id,
    };

    // console.log("New message toast:", formattedMessage);

    // Add new toast to the array
    setToasts((prev) => [formattedMessage, ...prev].slice(0, 3));

    // Auto-remove toast after 5 seconds
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== formattedMessage.id));
    }, 5000);
  };
  // Handle click on toast notification
  const handleToastClick = (toastData) => {
    // Remove the toast
    setToasts((prev) => prev.filter((t) => t.id !== toastData.id));

    // Mark messages as read using full_number
    WhatsAppAPI.markMessagesAsRead(toastData.from, selectedSetting);

    // Navigate to whatsapp_messenger
    navigate("/whatsapp_messenger", {
      state: {
        fromNotification: true,
        phoneNumber: toastData.from,
        messageId: toastData.messageId,
        autoOpenChat: true,
      },
    });
  };

  const formatPhoneNumber = (number) => {
    const shouldHideNumber =
      userInfo?.userrole !== "ADMIN" &&
      userInfo?.is_whatsapp_number_hidden === true;

    if (shouldHideNumber && number) {
      const numberString = String(number);
      if (numberString.length <= 5) return numberString;
      const visibleDigits = numberString.slice(-5);
      const maskedDigits = "X".repeat(numberString.length - 5);
      return `${maskedDigits}${visibleDigits}`;
    }
    return number;
  };

  const handleNewLeadAssignment = (data) => {
    const newNotification = {
      id: Date.now() + Math.random(),
      type: "lead",
      message: data.message,
      lead: {
        ...data.lead,
        display_whatsapp_number: formatPhoneNumber(data.lead.whatsapp_number),
      },
      assignedBy: data.assignedBy,
      timestamp: data.timestamp || new Date(),
      read: false,
    };

    setLeadNotifications((prev) => {
      const filtered = prev.filter(
        (notif) => notif.lead.whatsapp_number !== data.lead.whatsapp_number,
      );
      const updated = [...filtered, newNotification].sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp),
      );
      return updated.slice(0, 50);
    });

    // Browser notification
    if ("Notification" in window) {
      if (Notification.permission === "granted") {
        new Notification("New Lead Assigned", {
          body: data.message,
          icon: "/lead-icon.png",
          tag: "lead-assignment",
        });
      } else if (Notification.permission === "default") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            new Notification("New Lead Assigned", {
              body: data.message,
              icon: "/lead-icon.png",
              tag: "lead-assignment",
            });
          }
        });
      }
    }

    playNotificationSound();
  };

  const playNotificationSound = () => {
    if (!soundUnlockedRef.current || !audioRef.current) {
      // console.log("⚠️ Sound not unlocked yet");
      return;
    }

    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(() => {});
  };

  // Mark lead notification as read
  const markLeadNotificationAsRead = async (notificationId, leadId) => {
    setLeadNotifications((prev) =>
      prev.map((notif) =>
        notif.id === notificationId ? { ...notif, read: true } : notif,
      ),
    );
  };

  // Mark all lead notifications as read
  const markAllLeadNotificationsAsRead = async () => {
    setLeadNotifications((prev) =>
      prev.map((notif) => ({ ...notif, read: true })),
    );
    try {
      await WhatsAppAPI.deleteAllAssignedLeads();
    } catch (e) {
      // console.log("Failed to delete all assigned leads:", e);
    }
  };

  // Get unread lead notifications count
  const getUnreadLeadNotificationsCount = () => {
    return leadNotifications.filter((notif) => !notif.read).length;
  };

  // Navigate to lead details
  const navigateToLead = (leadId) => {
    setShowLeadNotif(false);
    navigate(`/leads/${leadId}`);
  };

  const fetchData = async () => {
    try {
      const response = await WhatsAppAPI.getWhatsAppSettingRecord();
      if (response.success) {
        const selectedWhatsAppSetting = sessionStorage.getItem(
          "selectedWhatsAppSetting",
        );
        const initialSetting = response.record.find(
          (record) => record.phone === selectedWhatsAppSetting,
        )
          ? selectedWhatsAppSetting
          : (() => {
              const newPhone = response.record[0]?.phone;
              sessionStorage.setItem("selectedWhatsAppSetting", newPhone);
              return newPhone;
            })();

        onWhatsAppSettingChange(initialSetting);
        setSelectedSetting(initialSetting);
        setWhatsappSetting(response.record);
      } else {
        setWhatsappSetting([]);
      }
    } catch (error) {
      // console.log('Error fetching WhatsApp settings:', error);
      setWhatsappSetting([]);
    }
  };

  const handleSettingChange = (e) => {
    const selectedId = e.target.value;
    setSelectedSetting(selectedId);
    sessionStorage.setItem("selectedWhatsAppSetting", selectedId);
    if (onWhatsAppSettingChange) {
      onWhatsAppSettingChange(selectedId);
    }
    if (socket) {
      socket.emit("business_number_changed", {
        deviceId: localStorage.getItem("deviceId"),
        business_number: selectedId,
      });
    }
  };

  const logout = () => {
    authApi.logout();
    navigate("/login");
  };

  const toggleSidebar = () => {
    document.querySelector("#sidebar").classList.toggle("hide");
    document.querySelector("#sidebar").classList.toggle("show");
  };
  // Fetch unread messages - SIMPLIFIED VERSION
  const fetchUnreadMessages = async () => {
    if (!selectedSetting) return;
    try {
      const unreadCountsRes =
        await WhatsAppAPI.fetchUnreadMsgCount(selectedSetting);

      if (
        unreadCountsRes &&
        unreadCountsRes.records &&
        unreadCountsRes.records.length > 0
      ) {
        const formattedMessages = unreadCountsRes.records.map((item) => {
          const phoneWithoutPlus = item.whatsapp_number?.replace("+", "") || "";
          const phoneForDisplay =
            phoneWithoutPlus.length > 10
              ? phoneWithoutPlus.substring(2)
              : phoneWithoutPlus;

          return {
            id: item.parent_id,
            whatsapp_number: phoneForDisplay,
            full_number: item.whatsapp_number, // This is the full number with +
            display_whatsapp_number: formatPhoneNumber(phoneForDisplay),
            display_full_number: formatPhoneNumber(phoneWithoutPlus),
            unread_msg_count: parseInt(item.unread_msg_count) || 0,
            name: item.name || phoneForDisplay,
            parent_id: item.parent_id,
            createddate: item.createddate,
            message_createddate: item.createddate,
          };
        });

        const contactsWithUnread = formattedMessages.filter(
          (msg) => msg.unread_msg_count > 0,
        );
        // console.log("contactsWithUnread", contactsWithUnread);

        // Create a map for easy lookup by phone number
        const unreadMap = {};
        contactsWithUnread.forEach((contact) => {
          // Store with both full_number and whatsapp_number (without +) for matching
          if (contact.full_number) {
            unreadMap[contact.full_number] = contact;
            // Also store without + for flexibility
            const numberWithoutPlus = contact.full_number.replace("+", "");
            unreadMap[numberWithoutPlus] = contact;
          }
        });

        // Update both state and ref
        setUnreadContactsMap(unreadMap);
        unreadContactsMapRef.current = unreadMap; // Update the ref
        setUnreadMessages(contactsWithUnread);
      } else {
        setUnreadContactsMap({});
        unreadContactsMapRef.current = {}; // Update the ref
        setUnreadMessages([]);
      }
    } catch (e) {
      console.error("Error fetching unread messages:", e);
      setUnreadContactsMap({});
      unreadContactsMapRef.current = {}; // Update the ref
      setUnreadMessages([]);
    }
  };

  // Mark messages as read for a contact
  const markContactMessagesAsRead = async (contact) => {
    try {
      // Use full_number if available, otherwise use whatsapp_number with country_code
      const phoneNumber =
        contact.full_number ||
        (contact.country_code && contact.whatsapp_number
          ? `${contact.country_code}${contact.whatsapp_number}`
          : contact.whatsapp_number);

      await WhatsAppAPI.markMessagesAsRead(phoneNumber, selectedSetting);

      // Remove from unread list
      setUnreadMessages((prev) => prev.filter((m) => m.id !== contact.id));

      // Update both state and ref
      setUnreadContactsMap((prev) => {
        const newMap = { ...prev };
        delete newMap[phoneNumber];
        delete newMap[phoneNumber.replace("+", "")];

        // Also update the ref
        unreadContactsMapRef.current = newMap;

        return newMap;
      });

      return true;
    } catch (error) {
      console.error("Error marking messages as read:", error);
      return false;
    }
  };

  const markAllMessagesAsRead = async () => {
    try {
      await WhatsAppAPI.markMessagesAsRead(null, selectedSetting);
      setUnreadMessages([]);
      setUnreadContactsMap({});
      unreadContactsMapRef.current = {}; // Clear the ref

      return true;
    } catch (error) {
      console.error("Error marking all messages as read:", error);
      return false;
    }
  };

  return (
    <>
      {/* Toast Notifications Container */}
      <ToastContainer
        className="p-3"
        position="top-end"
        style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          zIndex: 9999,
        }}
      >
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            onClose={() =>
              setToasts((prev) => prev.filter((t) => t.id !== toast.id))
            }
            show={true}
            delay={5000}
            autohide
            bg="success"
            className="mb-2"
            style={{
              minWidth: "300px",
              maxWidth: "350px",
              border: "none",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
            onClick={() => handleToastClick(toast)}
          >
            <Toast.Header closeButton={false}>
              <FaWhatsapp className="me-2" />
              <strong className="me-auto">New WhatsApp Message</strong>
              <small className="text-muted">
                {moment(toast.timestamp).fromNow()}
              </small>
            </Toast.Header>
            <Toast.Body className="text-white">
              <div className="d-flex align-items-start">
                <div className="flex-grow-1">
                  <strong className="d-block">{toast.contactName}</strong>
                  <p className="mb-0 mt-1" style={{ fontSize: "0.9rem" }}>
                    {toast.message.length > 50
                      ? `${toast.message.substring(0, 50)}...`
                      : toast.message}
                  </p>
                </div>
                <Button
                  variant="link"
                  className="p-0 text-white ms-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    setToasts((prev) => prev.filter((t) => t.id !== toast.id));
                  }}
                >
                  <i className="fas fa-times"></i>
                </Button>
              </div>
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>

      <Navbar
        className="header px-2"
        bg=""
        expand="lg"
        variant=""
        style={{ marginBottom: isMobile ? "1rem" : "0" }}
      >
        <button
          type="button"
          id="sidebarCollapse"
          className="btn btn-info"
          onClick={toggleSidebar}
        >
          <i className="fas fa-align-left"></i>
        </button>
        <Navbar.Brand href="#home"></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <NavLink
              to="/myprofile"
              className="p-0 d-flex align-items-center"
              style={{ fontSize: ".9rem", textDecoration: "none" }}
            >
              {brokenImages.includes(`img-${userInfo.id}`) ? (
                <NameInitialsAvatar
                  size="30px"
                  textSize="12px"
                  bgColor="#49C858"
                  borderWidth="0px"
                  textColor="#fff"
                  name={userInfo.username}
                />
              ) : (
                <img
                  alt=""
                  style={{ height: "30px", width: "30px" }}
                  src={profileImage + "/" + userInfo.id}
                  className="rounded-circle"
                  onError={() =>
                    setBrokenImages((prev) => [...prev, `img-${userInfo.id}`])
                  }
                  id={`img-${userInfo.id}`}
                />
              )}
              <Badge
                style={{ fontSize: ".9rem" }}
                bg="light"
                text="dark"
                className="mx-2"
              >
                {userInfo.username}
              </Badge>
              <Badge bg="success" style={{ fontSize: ".9rem" }}>
                {userInfo.userrole}
              </Badge>
            </NavLink>

            <NavLink
              to="#"
              className="d-flex p-0"
              style={{ alignItems: "center", textDecoration: "none" }}
            >
              <span className="mx-2" style={{ fontSize: ".9rem" }}>
                Company
              </span>
              <Badge style={{ fontSize: ".9rem" }} bg="secondary">
                {userInfo.companyname}
              </Badge>
            </NavLink>
          </Nav>
          <Nav className="ml-auto d-flex align-items-center">
            {userInfo?.modules?.some((module) => module.url === "calls") && (
              <>
                {callEventReceived && (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip>
                        {showCallUI ? "Hide Call UI" : "Show Call UI"}
                      </Tooltip>
                    }
                  >
                    <Button
                      variant={showCallUI ? "danger" : "success"}
                      onClick={() => setShowCallUI((prev) => !prev)}
                      className="me-3"
                      title={showCallUI ? "Hide Call Panel" : "Show Call Panel"}
                      style={{
                        borderRadius: "50%",
                        width: 45,
                        height: 30,
                        padding: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FaPhoneAlt size={12} />
                    </Button>
                  </OverlayTrigger>
                )}

                <IncomingCalls
                  socket={socket}
                  selectedBusinessNumber={selectedSetting}
                  showCallUI={showCallUI}
                  setCallEventReceived={setCallEventReceived}
                />
              </>
            )}
            {userInfo.userrole === "USER" && (
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                  marginRight: 12,
                }}
              >
                <span ref={leadNotifRef}>
                  <FaUserPlus
                    size={20}
                    style={{
                      cursor: "pointer",
                      color:
                        getUnreadLeadNotificationsCount() > 0
                          ? "#ff6b35"
                          : "#666",
                    }}
                    onClick={() => setShowLeadNotif(!showLeadNotif)}
                    title="Lead Assignments"
                  />
                </span>
                {getUnreadLeadNotificationsCount() > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: -4,
                      right: -4,
                      background: "#ff6b35",
                      color: "white",
                      borderRadius: "50%",
                      fontSize: 10,
                      minWidth: 18,
                      height: 18,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 2,
                    }}
                  >
                    {getUnreadLeadNotificationsCount()}
                  </span>
                )}
                <Overlay
                  show={showLeadNotif}
                  target={leadNotifRef.current}
                  placement="bottom"
                  containerPadding={20}
                  rootClose
                  onHide={() => setShowLeadNotif(false)}
                >
                  <Popover
                    id="lead-notif-popover"
                    style={{ minWidth: 350, maxWidth: 400 }}
                  >
                    <Popover.Header
                      as="h6"
                      className="d-flex justify-content-between align-items-center"
                    >
                      <span>Lead Assignments</span>
                      {leadNotifications.length > 0 && (
                        <Button
                          variant="link"
                          size="sm"
                          className="p-0 text-primary text-decoration-none"
                          onClick={markAllLeadNotificationsAsRead}
                        >
                          Mark all read
                        </Button>
                      )}
                    </Popover.Header>
                    <Popover.Body className="p-0">
                      <div style={{ maxHeight: 300, overflowY: "auto" }}>
                        {leadNotifications.length === 0 ? (
                          <div className="text-center py-4 text-muted">
                            No lead assignments
                          </div>
                        ) : (
                          leadNotifications.map((notif) => {
                            const timeAgo = moment(notif.timestamp).fromNow();
                            return (
                              <div
                                key={notif.id}
                                className={`d-flex align-items-start py-3 px-3 border-bottom ${
                                  !notif.read ? "bg-light" : ""
                                }`}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  markLeadNotificationAsRead(
                                    notif.id,
                                    notif.lead.id,
                                  );
                                  navigateToLead(notif.lead.id);
                                  setShowLeadNotif(false);
                                }}
                              >
                                <div className="me-3 mt-1">
                                  <NameInitialsAvatar
                                    name={
                                      notif.lead.firstname +
                                      " " +
                                      notif.lead.lastname
                                    }
                                    size="35px"
                                    textSize="12px"
                                    bgColor={fillNotifBgColor()}
                                    borderWidth="0px"
                                    textColor="#fff"
                                  />
                                </div>
                                <div className="flex-grow-1">
                                  <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                      <b className="d-block">
                                        {notif.lead.firstname}{" "}
                                        {notif.lead.lastname}
                                      </b>
                                      <small className="text-muted">
                                        {notif.lead.country_code}{" "}
                                        {notif.lead.display_whatsapp_number ||
                                          formatPhoneNumber(
                                            notif.lead.whatsapp_number,
                                          )}
                                      </small>
                                    </div>
                                    {!notif.read && (
                                      <span
                                        className="badge bg-primary"
                                        style={{ fontSize: 9 }}
                                      >
                                        NEW
                                      </span>
                                    )}
                                  </div>
                                  <div
                                    className="text-muted mt-1"
                                    style={{ fontSize: "0.8rem" }}
                                  >
                                    {notif.message}
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center mt-2">
                                    <small className="text-muted">
                                      By: {notif.assignedBy?.name || "System"}
                                    </small>
                                    <small className="text-muted">
                                      {timeAgo}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </Popover.Body>
                  </Popover>
                </Overlay>
              </div>
            )}
            {/* Notification Bell */}
            <div
              style={{
                position: "relative",
                display: "inline-block",
                marginRight: 12,
              }}
            >
              <span ref={notifRef}>
                <FaBell
                  size={20}
                  style={{ cursor: "pointer", color: "#333" }}
                  onClick={() => setShowNotif(!showNotif)}
                />
              </span>
              {unreadMessages.length > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: -4,
                    right: -4,
                    background: "red",
                    color: "white",
                    borderRadius: "50%",
                    fontSize: 12,
                    padding: "2px 6px",
                    zIndex: 2,
                  }}
                >
                  {unreadMessages.length}
                </span>
              )}
              <Overlay
                show={showNotif}
                target={notifRef.current}
                placement="bottom"
                containerPadding={20}
                rootClose
                onHide={() => setShowNotif(false)}
              >
                <Popover
                  id="unread-popover"
                  style={{ minWidth: 350, maxWidth: 400 }}
                >
                  <Popover.Header
                    as="h6"
                    className="d-flex justify-content-between align-items-center"
                  >
                    <span>Unread Messages</span>
                    <div>
                      <Button
                        variant="link"
                        size="sm"
                        className="p-0 me-2"
                        onClick={fetchUnreadMessages}
                        title="Refresh"
                      >
                        <i className="fas fa-sync-alt"></i>
                      </Button>
                      {unreadMessages.length > 0 && (
                        <Button
                          variant="link"
                          size="sm"
                          className="p-0 text-primary text-decoration-none"
                          onClick={async () => {
                            await markAllMessagesAsRead();
                          }}
                        >
                          Mark all read
                        </Button>
                      )}
                    </div>
                  </Popover.Header>
                  <Popover.Body className="p-0">
                    <div style={{ maxHeight: 260, overflowY: "auto" }}>
                      {unreadMessages.length === 0 ? (
                        <div className="text-center py-4">
                          No unread messages
                        </div>
                      ) : (
                        unreadMessages.map((msg, idx) => {
                          const created = moment(
                            msg.message_createddate || msg.createddate,
                          );
                          return (
                            <div
                              key={msg.id || msg.whatsapp_number}
                              className="d-flex align-items-center py-3 px-3 border-bottom"
                              style={{ cursor: "pointer" }}
                              onClick={async () => {
                                // Mark messages as read using full_number
                                await markContactMessagesAsRead(msg);

                                // Redirect to leads page with lead id
                                if (msg.id) {
                                  navigate(`/leads/${msg.id}`, {
                                    state: {
                                      leadName: msg.name || msg.contactname,
                                      leadPhone:
                                        msg.full_number || msg.whatsapp_number,
                                      fromNotification: true,
                                      unreadMessages: msg.unread_msg_count,
                                    },
                                  });
                                } else {
                                  navigate("/whatsapp_messenger", {
                                    state: {
                                      searchPhone:
                                        msg.full_number || msg.whatsapp_number,
                                      contactName: msg.name || msg.contactname,
                                      fromNotification: true,
                                      autoOpenChat: true,
                                    },
                                  });
                                }

                                // Close the notification popover
                                setShowNotif(false);
                              }}
                            >
                              <div className="me-3">
                                <NameInitialsAvatar
                                  name={
                                    msg.name ||
                                    msg.contactname ||
                                    msg.whatsapp_number
                                  }
                                  size="30px"
                                  textSize="13px"
                                  bgColor={bgColors[idx % bgColors.length]}
                                  borderWidth="0px"
                                  textColor="#fff"
                                />
                              </div>
                              <div className="flex-grow-1">
                                <div>
                                  <b>
                                    {msg.name ||
                                      msg.contactname ||
                                      msg.display_whatsapp_number ||
                                      formatPhoneNumber(msg.whatsapp_number)}
                                  </b>
                                  <Badge
                                    bg="success"
                                    pill
                                    className="ms-2"
                                    style={{ fontSize: 10 }}
                                  >
                                    {msg.unread_msg_count}
                                  </Badge>
                                </div>
                                <small className="text-muted">
                                  {msg.display_full_number ||
                                    msg.full_number ||
                                    `${msg.country_code}${msg.whatsapp_number}`}
                                </small>
                                <div>
                                  <small className="text-muted">
                                    Last message:{" "}
                                    {created.format("D MMM YYYY, h:mm a")}
                                  </small>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                    <div
                      className="border-top w-100 d-flex justify-content-center align-items-center"
                      style={{
                        minHeight: 40,
                        background: "#fff",
                        position: "sticky",
                        bottom: 0,
                      }}
                    >
                      <span
                        className="fw-semibold text-secondary"
                        style={{
                          cursor: "pointer",
                          fontSize: 12,
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={async () => {
                          await markAllMessagesAsRead();
                          navigate("/whatsapp_messenger", {
                            state: {
                              fromNotification: true,
                              markedAllAsRead: true,
                            },
                          });
                          setShowNotif(false);
                        }}
                      >
                        <i
                          className="fa fa-envelope me-2"
                          style={{ fontSize: 14 }}
                        />
                        Read All Messages
                      </span>
                    </div>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>

            {whatsappSetting.length > 0 && userInfo.userrole != "SYS_ADMIN" && (
              <Form.Select
                value={selectedSetting}
                onChange={handleSettingChange}
                aria-label="Select WhatsApp Setting"
                className="me-4"
              >
                {whatsappSetting.map((setting, index) => (
                  <option
                    key={`${setting.phone}-${setting.id || index}`}
                    value={setting.phone}
                  >
                    {setting.name} {setting.phone}
                  </option>
                ))}
              </Form.Select>
            )}

            {sessionStorage.getItem("token") ? (
              <Button variant="btn btn-primary" onClick={logout} title="Logout">
                <i className="fa-solid fa-right-from-bracket"></i>
              </Button>
            ) : (
              <></>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};
export default Header;
